<template>
  <div class="learning-component-container pt-10">
    <a-row :gutter="32">
      <a-col :span="24">
        <div class="mb-30">
          <p class="font-web mb-10 text-dark font-weight-bold">
            Essential information and forms for Individual Development Plan (IDP).
          </p>
        </div>

        <div class="idp-images-container mb-30">
          <img
            v-for="(img, imgIdx) in images"
            :key="imgIdx"
            :src="img"
            alt="IDP Essentials"
            class="onboarding-item-img clickable-img"
            @click="openPreview(img)"
          />
        </div>

        <div class="section-block mb-30">
          <h3 class="section-title">เอกสาร / Documents</h3>
          <div v-if="item && item.docs && item.docs.length > 0" class="mt-15">
            <table class="doc-table">
              <thead>
                <tr>
                  <th>รายการไฟล์ / File List</th>
                  <th class="text-center">Download</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(doc, idx) in item.docs" :key="idx">
                  <td>
                    <div class="file-name-main">{{ doc.name }}</div>
                    <div v-if="doc.updatedAt" class="file-date">อัปเดตเมื่อ: {{ formatDate(doc.updatedAt) }}</div>
                  </td>
                  <td class="text-center">
                    <a v-if="doc.link && doc.link !== '#'" :href="doc.link" target="_blank" rel="noopener noreferrer" class="download-link">
                      <a-icon type="download" />
                    </a>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-muted mt-10 italic">ไม่พบข้อมูล / No data found</div>
        </div>
      </a-col>
    </a-row>

    <!-- Image Preview Modal -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false" centered width="80%">
      <img alt="Preview" style="width: 100%; border-radius: 8px;" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({ docs: [] })
    }
  },
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      images: [
        '/images/hri_dashboard/IDPEssentialsA.png',
        '/images/hri_dashboard/IDPEssentialsB.png',
        '/images/hri_dashboard/IDPEssentialsC.png'
      ]
    };
  },
  methods: {
    openPreview(imgSrc) {
      this.previewImage = imgSrc;
      this.previewVisible = true;
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
  }
};
</script>

<style scoped>
.idp-images-container {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 15px;
}
.onboarding-item-img {
  width: 280px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  object-fit: cover;
  transition: transform 0.3s ease;
}
.clickable-img {
  cursor: pointer;
}
.clickable-img:hover {
  transform: scale(1.02);
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 8px;
}

.section-block {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.text-muted { color: #8c8c8c; }
.text-dark { color: #1a1a2e; }
.font-weight-bold { font-weight: 600; }
.italic { font-style: italic; }

/* Document Table Styles */
.doc-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.doc-table th {
  background: #f8f9fa;
  padding: 12px 15px;
  text-align: left;
  font-weight: 700;
  color: #1a1a2e;
  border-bottom: 2px solid #e8e8e8;
  font-size: 14px;
}

.doc-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
  color: #434343;
  font-size: 14px;
}

.file-name-main {
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.4;
}

.file-date {
  font-size: 11px;
  color: #bfbfbf;
  margin-top: 4px;
}

.text-center { text-align: center; }

.download-link {
  color: #4285F4;
  font-size: 18px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.download-link:hover {
  color: #1a73e8;
  transform: translateY(-2px);
}

.mt-15 { margin-top: 15px; }
.mb-10 { margin-bottom: 10px; }
.mb-30 { margin-bottom: 30px; }
.pt-10 { padding-top: 10px; }

@media (max-width: 768px) {
  .onboarding-item-img {
    width: 100% !important;
    max-width: 320px;
    margin-top: 10px;
  }
}
</style>
